export const terminate = () => {
    return {
        width:'1150px',
        title: '终止流程示意',
        height: '580px',
        ranksep:75,
        nodesep:25,
        nodes: [
            {
                id: 'start',
                data: { number:20,label: '提交合同终止申请' },
                type: 'rect',
                style: { size: 60, labelMaxWidth: 45, fill:'#D8D839' },
            },
            {
                id: 'contractStatus',
                data: {  label: '判定合同状态' },
                type: 'diamond',
                style: { size: 80, labelMaxWidth: 60, fill:'#DF9931' },
            },
            {
                id: 'noMachineTestItems1',
                data: {label: '项目管理系统内是否存在上机测序项目'},
                type: 'diamond',
                style: { size: [150, 80], labelMaxWidth: 85, fill: '#DF9931' }
            },
            {
                id: 'noMachineTestItems2',
                data: { label: '项目管理系统内是否存在上机测序项目' },
                type: 'diamond',
                style: { size: [150, 80], labelMaxWidth: 85, fill: '#DF9931' }
            },
            {
                id: 'success1',
                data: { number:55,label: '合同无需审批直接终止' },
                type: 'rect',
                style: { size: [100, 60], labelMaxWidth: 80, fill: '#3CC457' }
            },
            {
                id: 'error1',
                data: { number: 55, label: '报错提示' },
                type: 'rect',
                style: { size: [100, 40], labelMaxWidth: 80, fill: '#eb0b0b' },
            },
            {
                id: 'error2',
                data: { number: 55, label: '报错提示' },
                type: 'rect',
                style: { size: [100, 40], labelMaxWidth: 80, fill: '#eb0b0b' },
            },
            {
                id: 'noInvoiced',
                data: { number: 75, label: '是否满足未开发票或申请发票被驳回或所开发票都退票' },
                type: 'diamond',
                style: { size: [160, 95], labelMaxWidth: 75, fill: '#DF9931' },
            },
            {
                id: 'error3',
                data: { label: '报错提示' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill: '#eb0b0b' },
            },
            {
                id: 'audit',
                data: {label: '审批'+`\n`+'审批人:实验室' },
                type: 'rect',
                style: { size: [90,50], labelMaxWidth: 70, },
            },
            {
                id: 'success2',
                data: { number:70, label: '合同终止' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill:'#3CC457' },
            },
            {
                id: 'defeat',
                data: { number: 70, label: '未通过审批' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill:'#eb0b0b' },
            },
        ],
        edges: [
            {
                id: '1',
                source: 'start',
                target: 'contractStatus',
                type: 'line'
            },
            {
                id: '2',
                source: 'contractStatus',
                target: 'noMachineTestItems1',
                type: 'polyline',
                data: { label: '待审核合同或已驳回合同' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
            {
                id: '3',
                source: 'contractStatus',
                target: 'noMachineTestItems2',
                type: 'polyline',
                data: {label: '已通过合同' + `\n` + '审批人: 詹海燕' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                id: '4',
                source: 'noMachineTestItems1',
                target: 'success1',
                type: 'polyline',
                data: { label: '否' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
            {
                id: '5',
                source: 'noMachineTestItems1',
                target: 'error1',
                type: 'polyline',
                data: { label: '是' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                id: '6',
                source: 'noMachineTestItems2',
                target: 'error2',
                type: 'polyline',
                data: { label: '是' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
            {
                id: '7',
                source: 'noMachineTestItems2',
                target: 'noInvoiced',
                type: 'polyline',
                data: { label: '否' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                id: '8',
                source: 'noInvoiced',
                target: 'error3',
                type: 'polyline',
                data: { label: '否' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
            {
                id: '9',
                source: 'noInvoiced',
                target: 'audit',
                type: 'polyline',
                data: { label: '是' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                id: '10',
                source: 'audit',
                target: 'success2',
                type: 'polyline',
                data: { label: '通过审批' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
            {
                id: '11',
                source: 'audit',
                target: 'defeat',
                type: 'polyline',
                data: { label: '未通过审批' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
        ]
    }
}